import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  ReportDesignItemText,
  ReportDesignItemTextConfig
} from "../../report-design-item";

@Component({
  selector: "snt-report-designer-text",
  templateUrl: "report-designer-text.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerTextComponent implements OnInit {
  @Input()
  item!: ReportDesignItemText;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output() config: EventEmitter<ReportDesignItemTextConfig> =
    new EventEmitter();

  formData: {
    title: string;
    multiline: boolean;
    required: boolean;
    dataType: string;
  } = {
    title: "",
    multiline: false,
    required: false,
    dataType: "text"
  };

  ngOnInit(): void {
    this.formData.title = this.item.config?.title || "";
    this.formData.multiline = this.item.config?.multiline || false;
    this.formData.required = this.item.config?.required || false;
    this.formData.dataType = this.item.config?.dataType || "text";
  }

  onFieldDataChanged(): void {
    this.config.emit({
      ...this.item.config,
      ...this.formData
    });
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    return {
      type: "text",
      config: {
        title: this.formData.title,
        value: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`
      }
    };
  }
}
